export default __webpack_public_path__ + "static/media/map.7be0345b.png";